import { Box, BoxProps, CardProps } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

export interface TableUpdateStatusCellProps {
  /** cell header */
  header?: string;
  /** cell body text */
  body: string;
  /** icon beside the body text */
  icon?: string;
  /** chip background color */
  chipColor?: string;
  /** Additional MUI styling */
  cardProps?: CardProps;
  /** Additional header styling */
  headerProps?: BoxProps;
  /** chip props */
  chipProps?: BoxProps;
}

export const TableUpdateStatusCell: PimoReactComponent<
  TableUpdateStatusCellProps
> = ({
  header,
  body,
  icon,
  chipColor,
  cardProps = {},
  chipProps = {},
  headerProps = {},
}) => {
  return (
    <Box {...cardProps} sx={{ ...cardProps.sx }}>
      {header && (
        <Box {...headerProps} sx={{ ...headerProps.sx }}>
          {header}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "left",
          height: "2em",
        }}
      >
        <Box
          {...chipProps}
          sx={{
            textAlign: "center",
            py: "auto",
            px: "1em",
            borderRadius: "12px",
            backgroundColor: chipColor,
            display: "flex",
            alignItems: "center",
            fontWeight: 500,
            lineHeight: "2em",
            height: "2em",
            overflow: "hidden",
            ...chipProps.sx,
          }}
        >
          {body}
          {icon && <Box component="img" src={icon} sx={{ pl: 1 }}></Box>}
        </Box>
      </Box>
    </Box>
  );
};

export default TableUpdateStatusCell;
